<ion-header class="ion-no-border">
  <ion-toolbar>
    @if ((addingLessonRatings$ | async) || (removingLessonRatings$ | async)) {
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    }
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Schliessen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    @if (hasComments()) {
      <ion-buttons slot="end">
        <ion-button (click)="listComments() ? listComments.set(false) : listComments.set(true)">
          <ion-icon
            [name]="listComments() ? 'chevron-collapse-outline' : 'chevron-expand-outline'"
            slot="icon-only"
            size="large"
            ></ion-icon>
        </ion-button>
      </ion-buttons>
    }
    <ion-title>{{ readMode() ? 'Ausbildung (' + (appointment()?.StartTime | date:"dd.MM.yyyy") + ')' : 'Ausbildung' }}</ion-title>
  </ion-toolbar>
  <!-- if the lessonRatingForm contains any controls - show the segments -->
  @if ((currentLessonRatings$ | async)?.length > 0 && !(readMode() && appointment() !== null)) {
  <ion-toolbar mode="ios">
    <ion-segment [(ngModel)]="section" (ngModelChange)="segmentChanged($event)">
      <ion-segment-button value="planned">
        <ion-label>Geplant</ion-label>
      </ion-segment-button>
      <ion-segment-button value="all">
        <ion-label>Alle</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
  }
</ion-header>
@if (studentLessonRatings$ | async) {
<ion-content>
  @if (!isRating && !(readMode() && appointment() !== null)) {
    <ion-grid class="sticky-header">
      <ion-row class="row">
        <ion-col class="col title" [ngStyle]="{ width: 'calc(100% - ' + (numberOfRatingsDisplayed() * 42) + 'px)'}"></ion-col>
        @for (lesson of displayedLessons; track lesson) {
          <ion-col
            class="col w-10 col-border-top"
            [ngClass]="{
              'current-lesson': appointment()?.Id === lesson.Id,
            }"
          >
            <div class="date-container">
              {{ lesson.StartTime | date : "dd.MM" }}
            </div>
          </ion-col>
        }
      </ion-row>
    </ion-grid> 
  }
  @for (educationTitle of displayedEducationCategory?.education_title; track
  educationTitle) {
  <form [formGroup]="lessonRatingForm">
    <ion-item-group>
      <ion-item-divider mode="ios">
        <ion-label>{{ educationTitle.title }}</ion-label>
      </ion-item-divider>
      @for (educationBody of educationTitle.education_body; track educationBody)
      { @if (isPlanning) {
      <ion-checkbox
        [formControl]="
          lessonRatingForm.get(
            educationBody.education_body_id.toString() + '.selected'
          )
        "
        labelPlacement="end"
        justify="start"
        class="pl-4 w-full"
      >
        <ion-grid>
          <ion-row class="row">
            <ion-col class="col title" [ngStyle]="{ width: 'calc(100% - ' + (numberOfRatingsDisplayed() * 42) + 'px)'}">
              <div class="ellipsis-container">
                {{ educationBody.body }}
              </div>
            </ion-col>
            @for (lesson of displayedLessons; track lesson) {
              <ion-col
                class="col w-10"
                [ngClass]="{
                  'rating-1': getRating(educationBody, lesson) === 1,
                  'rating-2': getRating(educationBody, lesson) === 2,
                  'rating-3': getRating(educationBody, lesson) === 3,
                  'rating-4': getRating(educationBody, lesson) === 4,
                  'rating-5': getRating(educationBody, lesson) === 5,
                  'rating-6': getRating(educationBody, lesson) === 6,
                  'no-rating': !getRating(educationBody, lesson)
                }"
              >
                <div class="rating-container">
                  {{ getRating(educationBody, lesson) || "⦻" }}
                </div>
              </ion-col>
            }
          </ion-row>
        </ion-grid>
      </ion-checkbox>
      } @else if (isRating) {
      <ion-grid>
        <ion-row class="row">
          <ion-col>
            <div class="ellipsis-container">{{ educationBody.body }}</div>
          </ion-col>
        </ion-row>
        <ion-row class="row">
          <ion-col class="rating-col pb-4 !justify-start pl-4">
            <ion-radio-group
              [formControl]="
                lessonRatingForm.get(
                  educationBody.education_body_id.toString() + '.rating'
                )
              "
              (ionChange)="onRatingChange($event, educationBody)"
              [allowEmptySelection]="true"
              class="radio-group-container"
            >
              <ion-radio
                [value]="1"
                [ngClass]="{
                  checked: getRating(educationBody) >= 1,
                  'checked-1': getRating(educationBody) === 1,
                  'checked-2': getRating(educationBody) === 2,
                  'checked-3': getRating(educationBody) === 3,
                  'checked-4': getRating(educationBody) === 4,
                  'checked-5': getRating(educationBody) === 5,
                  'checked-6': getRating(educationBody) === 6
                }"
              ></ion-radio>
              <ion-radio
                [value]="2"
                [ngClass]="{
                  checked: getRating(educationBody) >= 2,
                  'checked-1': getRating(educationBody) === 1,
                  'checked-2': getRating(educationBody) === 2,
                  'checked-3': getRating(educationBody) === 3,
                  'checked-4': getRating(educationBody) === 4,
                  'checked-5': getRating(educationBody) === 5,
                  'checked-6': getRating(educationBody) === 6
                }"
              ></ion-radio>
              <ion-radio
                [value]="3"
                [ngClass]="{
                  checked: getRating(educationBody) >= 3,
                  'checked-1': getRating(educationBody) === 1,
                  'checked-2': getRating(educationBody) === 2,
                  'checked-3': getRating(educationBody) === 3,
                  'checked-4': getRating(educationBody) === 4,
                  'checked-5': getRating(educationBody) === 5,
                  'checked-6': getRating(educationBody) === 6
                }"
              ></ion-radio>
              <ion-radio
                [value]="4"
                [ngClass]="{
                  checked: getRating(educationBody) >= 4,
                  'checked-1': getRating(educationBody) === 1,
                  'checked-2': getRating(educationBody) === 2,
                  'checked-3': getRating(educationBody) === 3,
                  'checked-4': getRating(educationBody) === 4,
                  'checked-5': getRating(educationBody) === 5,
                  'checked-6': getRating(educationBody) === 6
                }"
              ></ion-radio>
              <ion-radio
                [value]="5"
                [ngClass]="{
                  checked: getRating(educationBody) >= 5,
                  'checked-1': getRating(educationBody) === 1,
                  'checked-2': getRating(educationBody) === 2,
                  'checked-3': getRating(educationBody) === 3,
                  'checked-4': getRating(educationBody) === 4,
                  'checked-5': getRating(educationBody) === 5,
                  'checked-6': getRating(educationBody) === 6
                }"
              ></ion-radio>
              <ion-radio
                [value]="6"
                [ngClass]="{
                  checked: getRating(educationBody) >= 6,
                  'checked-1': getRating(educationBody) === 1,
                  'checked-2': getRating(educationBody) === 2,
                  'checked-3': getRating(educationBody) === 3,
                  'checked-4': getRating(educationBody) === 4,
                  'checked-5': getRating(educationBody) === 5,
                  'checked-6': getRating(educationBody) === 6
                }"
              ></ion-radio>
            </ion-radio-group>
            <ion-button shape="round" fill="clear" class="comment-button" (click)="openCommentDialog(educationBody.education_body_id)">
              <ion-icon slot="icon-only" [name]="getComment(educationBody) ? 'chatbubble' : 'chatbubble-outline'"></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
      } @else {
      <ion-grid>
        <ion-row class="row">
          <ion-col class="col title" [ngStyle]="{ width: 'calc(100% - ' + (numberOfRatingsDisplayed() * 42) + 'px)'}" (click)="openHyperLink(educationBody.hyperlink)">
            <a [ngStyle]="{ 'color': educationBody.hyperlink ? 'var(--link-color)' : 'none', cursor: educationBody.hyperlink ? 'pointer' : 'default' }" class="ellipsis-container">
              {{ educationBody.body }}
            </a>
          </ion-col>
          @for (lesson of displayedLessons; track lesson) {
            <ion-col
              (click)="showComment(educationBody, lesson)"
              [ngStyle]="{'cursor': getComment(educationBody, lesson) ? 'pointer' : 'default'}"
              class="col w-10"
              [ngClass]="{
                'rating-1': getRating(educationBody, lesson) === 1,
                'rating-2': getRating(educationBody, lesson) === 2,
                'rating-3': getRating(educationBody, lesson) === 3,
                'rating-4': getRating(educationBody, lesson) === 4,
                'rating-5': getRating(educationBody, lesson) === 5,
                'rating-6': getRating(educationBody, lesson) === 6,
                'no-rating': !getRating(educationBody, lesson)
              }"
            >
              <div class="rating-container">
                @if (getComment(educationBody, lesson)) {
                  <div class="rounded bg-red-500 w-2 h-2 absolute right-1 top-1"></div>
                }
                {{ getRating(educationBody, lesson) || "⦻" }}
              </div>
            </ion-col>
          }
        </ion-row>
        @if (listComments()) {
          @let comments = getAllEducationBodyComments(educationBody);
          @if (comments.length > 0) {
            <ion-row>
              <ion-col class="col comment-col">
                @for (comment of comments; track comment) {
                  <li class="bullet-point">{{comment}}</li>
                }
              </ion-col>
            </ion-row>
          }
        }
      </ion-grid>
      } }
    </ion-item-group>
  </form>
  }
  @if ((displayedLessons.length < pastLessons.length) && !isRating && !(readMode() && appointment() !== null)) {
    <ion-fab horizontal="end" vertical="bottom" slot="fixed" class="right-16">
      <ion-fab-button size="small" color="light" (click)="navLeft()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-fab-button>
    </ion-fab>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button size="small" color="light" (click)="navRight()">
        <ion-icon name="arrow-forward-outline"></ion-icon>
      </ion-fab-button>
    </ion-fab> 
  }
</ion-content>
} @else {
  <ion-content>
    <ion-spinner class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></ion-spinner>
  </ion-content>
}


@if (appointment() && !readMode()) {
<ion-footer [translucent]="true">
  <ion-toolbar>
    @if (!isPlanning && !isRating) {
    <ion-buttons slot="start">
      <ion-button (click)="toggleIsPlanning()"> Lektion planen </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="toggleIsRating()"> Lektion bewerten </ion-button>
    </ion-buttons>
    } @else {
    <ion-buttons slot="start">
      <ion-button (click)="onCancel()"> Abbrechen </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="onSubmit()"> Speichern </ion-button>
    </ion-buttons>
    }
  </ion-toolbar>
</ion-footer>
}
